import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useIntl, defineMessages } from 'react-intl';

import { State } from '../../../lib/reducers';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { IconExpand, IconShrink } from '../../IconSet';

import { enlargeStreamVideo } from '../../../lib/actions/room';
import {
  getSelectedStream,
  areSecondaryVideosHidden,
} from '../../../lib/reduxSelectors/presentationLayout';
import { isPresentationLayout } from '../../../lib/reduxSelectors/room';

import useStyles from '../../../style/ControlButton';
import classNames from 'classnames';


const messages = defineMessages({
  enlargeTooltip: { id: 'enlargeIconButtonTooltip' },
  collapseTooltip: { id: 'collapseIconButtonTooltip' },
});


function MaximizeMainVideo(props: ExtendedProps) {
  const classes = useStyles();

  const { isPresentationLayout, isMainVideo, iconSize = 20, mini, secondaryVideosAreHidden } = props;

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const hideSecondaryVideos = () => {
    dispatch(enlargeStreamVideo(!secondaryVideosAreHidden));
  };

  const cls = classNames(classes.controlButton, mini ? classes.controlButtonMini : null);

  if (isPresentationLayout && isMainVideo) {
    const msg = formatMessage(
      (secondaryVideosAreHidden) ? messages.collapseTooltip : messages.enlargeTooltip
    );
    return (
      <Tooltip placement="top" title={msg}>
        <div>
          <IconButton
            onClick={hideSecondaryVideos}
            className={cls}
            size='small'
          >
            {secondaryVideosAreHidden ? <IconShrink size={iconSize} /> : <IconExpand size={iconSize} />}
          </IconButton>
        </div>
      </Tooltip>
    );
  }

  return null;
}


type Props = {
  uid: string;
  iconSize?: number;
  mini?: boolean;
}


type MappedProps = {
  isMainVideo: boolean;
  isPresentationLayout: boolean;
  secondaryVideosAreHidden: boolean;
}


type ExtendedProps = Props & MappedProps


const mapStateToProps = (state: State, { uid }: Props): MappedProps => {
  const selectedStream = getSelectedStream(state);
  return {
    secondaryVideosAreHidden: areSecondaryVideosHidden(state),
    isMainVideo: uid === selectedStream,
    isPresentationLayout: isPresentationLayout(state),
  };
};


export default connect(mapStateToProps)(MaximizeMainVideo);
